module.exports = __webpack_public_path__ + "img/goal.aa73533f.png";